import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
// import currency from "../../../utils/currency";
import tableIcons from "../../../components/tableicon/table-icons";
import Circle from "../../../components/appLoading/circle";
import TabPanel from "../../../components/TabPanel";
import MaterialTable from "material-table";

function TopProduk({ value }) {
  const { profil } = useData();
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState({
    columns: [
      { title: "Nama Produk", field: "nama_produk" },
      { title: "Terjual", field: "qty_terjual" },
    ],
    data: [],
  });

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getTopProducts");

      const res = await func({ user_id: profil?.id });

      if (!profil?.tipe_akun === "reseller") {
        setTable((table) => {
          return {
            ...table,
            data: res?.data.map((doc) => {
              return {
                // ...doc,
                nama_produk: doc.nama_produk,
                qty_terjual: doc.qty_terjual,
              };
            }),
          };
        });
      } else {
        setTable((table) => {
          return {
            ...table,
            data: [],
          };
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const Table = () => {
    return (
      <MaterialTable
        columns={table.columns}
        data={table.data}
        title="Daftar Produk"
        icons={tableIcons}
        components={{
          Container: (props) => <div {...props} elevation={0} />,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: `Tidak Ada Data ${
              profil?.tipe_akun === "reseller" ? " Bagi Reseller" : ""
            }`,
          },
          toolbar: {
            searchTooltip: "Cari",
            searchPlaceholder: "Cari Data",
          },
          header: {
            actions: "Actions",
          },
          pagination: {
            labelRowsSelect: "Baris",
            labelDisplayedRows: " {from}-{to} Dari {count} Baris",
            firstTooltip: "Halaman Pertama",
            previousTooltip: "Halaman Sebelumnya",
            nextTooltip: "Halaman Selanjutnya",
            lastTooltip: "Halaman Terakhir",
          },
        }}
      />
    );
  };


  return (
    <TabPanel value={value} index="produk">
      {loading ? <Circle size={25} /> : <Table />}
    </TabPanel>
  );
}

export default TopProduk;
